import React from 'react';
import { PropertyPanel, PropertyPanelSection } from './PropertyPanel';

export interface BcmEditState {
  elementId: string;
  name: string;
  level: 'domain' | 'capability' | 'subcapability';
  owner: string;
  maturity: number;
  status: 'active' | 'evolving' | 'retiring';
  x: number;
  y: number;
}

interface BcmPropertyPanelProps {
  editState: BcmEditState;
  onSave: (id: string, updates: Partial<BcmEditState>) => void;
  onClose: () => void;
}

const MATURITY_OPTIONS = [
  { value: '0', label: '0 — Не оценено' },
  { value: '1', label: '1 — Initial' },
  { value: '2', label: '2 — Managed' },
  { value: '3', label: '3 — Defined' },
  { value: '4', label: '4 — Optimized' },
  { value: '5', label: '5 — Leading' },
];

const STATUS_OPTIONS = [
  { value: 'active',   label: 'Active' },
  { value: 'evolving', label: 'Evolving' },
  { value: 'retiring', label: 'Retiring' },
];

export const BcmPropertyPanel: React.FC<BcmPropertyPanelProps> = ({ editState, onSave, onClose }) => {
  const sections: PropertyPanelSection[] = [
    {
      id: 'name',
      type: 'text-input',
      label: 'Название',
      value: editState.name,
      placeholder: 'Название capability…',
      onChange: (v: string) => onSave(editState.elementId, { name: v }),
    },
    {
      id: 'owner',
      type: 'text-input',
      label: 'Владелец',
      value: editState.owner,
      placeholder: 'Owner / responsible…',
      onChange: (v: string) => onSave(editState.elementId, { owner: v }),
    },
    {
      id: 'maturity',
      type: 'select',
      label: 'Зрелость',
      icon: String(editState.maturity),
      value: String(editState.maturity),
      options: MATURITY_OPTIONS,
      onChange: (v: string) => onSave(editState.elementId, { maturity: Number(v) }),
    },
    {
      id: 'status',
      type: 'select',
      label: 'Статус',
      icon: editState.status === 'active' ? '✓' : editState.status === 'evolving' ? '↑' : '↓',
      value: editState.status,
      options: STATUS_OPTIONS,
      onChange: (v: string) => onSave(editState.elementId, { status: v as BcmEditState['status'] }),
    },
  ];

  return (
    <PropertyPanel
      x={editState.x}
      y={editState.y}
      sections={sections}
      onClose={onClose}
    />
  );
};
